var registerLogIn = function () {
    const forms = new forms4i();
    const helpers = new formHelpers4i();
    const isRegistrationPage = document.getElementsByClassName("RegistrationForm")[0];
    const tokenInput = document.querySelectorAll('input[name=__RequestVerificationToken]')[0];
    const verificationToken = tokenInput ? tokenInput.value : "";
    const loadingIcon = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
    const submitBtn = document.getElementById("btnSubmit");
    let allSaleChecks, allProductChecks, allNewsChecks;

    const init = () => {
        if (isRegistrationPage) {
            const zipCode = document.getElementById("ZipCode");
            if (zipCode) maskZipCode(zipCode);
            maskPhoneNumbers();
            getAllCheckboxes();
            if (submitBtn) {
                const registerForm = document.getElementById("registerForm");
                registerForm && registerForm.addEventListener("submit", disableBtn);
            }
        }

        const submitSMSCode = document.getElementById("submitSMSVerifyCode");
        if (submitSMSCode) submitSMSCode.addEventListener("click", verify);

        if (submitBtn) {
            submitBtn.addEventListener("click", function (e) {
                // Always clear previous busy state before validating again
                resetSubmitButton();

                // now block ONLY if disabled after reset
                if (submitBtn.disabled) {
                    e.preventDefault();
                    return;
                }

                submitForm(e);

            });
        }

        wirePasswordResetLiveValidation();
        wireEmailValidation();
        wireLoginLiveValidation();
    };

    function resetSubmitButton() {
        if (!submitBtn) return;

        // remove disabled
        submitBtn.disabled = false;
        submitBtn.setAttribute("aria-disabled", "false");

        // remove busy class
        submitBtn.classList.remove("busyBtn");

        // remove spinner
        const sp = submitBtn.querySelector(".spinner");
        if (sp) sp.remove();
    }

    function wireLoginLiveValidation() {

        const email = document.getElementById("Email");
        const pwd = document.getElementById("Password");
        if (!submitBtn || !email || !pwd) return;

        const emailValid = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());
        const minLen = (() => {
            const v = pwd.getAttribute("data-val-length-min");
            const n = parseInt(v || "8", 10);
            return isNaN(n) ? 8 : n;
        })();
        const pwdValid = v => (v || "").length >= minLen;

        const sync = () => {
            enableBlueButton(submitBtn);
        };

        sync();
        ["input", "blur"].forEach(ev => { email.addEventListener(ev, sync); pwd.addEventListener(ev, sync); });
    }

    function wireEmailValidation() {
        const email = document.getElementById("Email"); // NOTE: capital E
        if (!submitBtn || !email) return;

        const isValidEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());
        const sync = () => {
            enableBlueButton(submitBtn);
        };

        // initialize and keep in sync
        sync();
        email.addEventListener("input", sync);
        email.addEventListener("blur", sync);
    }

    function wirePasswordResetLiveValidation() {
        const a = document.getElementById("NewPassword");
        const b = document.getElementById("NewPasswordConfirm");
        if (!submitBtn || !a || !b) return;

        const th = () => {
            const v = a.getAttribute("data-val-password-complexity-threshold");
            const n = parseInt(v || "3", 10);
            return isNaN(n) ? 3 : n;
        };
        const minLen = () => {
            const v = a.getAttribute("data-val-length-min");
            const n = parseInt(v || "8", 10);
            return isNaN(n) ? 8 : n;
        };
        const ok = pw => {
            let s = 0;
            if (/[a-z]/.test(pw)) s++;
            if (/[A-Z]/.test(pw)) s++;
            if (/\d/.test(pw)) s++;
            if (/[!@#^&*()+_,.{}?~]/.test(pw)) s++;
            return pw.length >= minLen() && s >= th();
        };
        const sync = () => {
            enableBlueButton(submitBtn);
        };

        sync();
        ["input", "blur"].forEach(ev => { a.addEventListener(ev, sync); b.addEventListener(ev, sync); });
    }

    function enableBlueButton(btn) {
        if (!btn) return;
        btn.classList.add("bkgdBlue");
        btn.disabled = false;
        btn.setAttribute("aria-disabled", "false");
    }

    const getAllCheckboxes = () => {
        const saleSection = document.getElementById("SaleSection");
        if (saleSection) allSaleChecks = saleSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']");
        const productSection = document.getElementById("ProductSection");
        if (productSection) allProductChecks = productSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']");
        const newsSection = document.getElementById("NewsletterSection");
        if (newsSection && newsSection.getElementsByTagName('ul').length > 0) allNewsChecks = newsSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']");
    };

    const maskZipCode = (zipCode) => {
        const zipMask = document.getElementById("ZipCodeMask");
        if (zipMask) {
            const zipCodeMaskPattern = zipMask.value;
            if (zipCodeMaskPattern != "") VMasker(zipCode).maskPattern(zipCodeMaskPattern);
        }
    };

    const maskPhoneNumbers = () => {
        const phoneMask = document.getElementById("phoneMask");
        forms.MaskPhoneNumber(phoneMask, document.getElementById("Phone"));
        forms.MaskPhoneNumber(phoneMask, document.getElementById("MobileNumber"));
    };

    const disableBtn = () => { submitBtn && (submitBtn.disabled = true); };

    const verify = (e) => {
        const codeInput = document.getElementById('code');
        if (codeInput && codeInput.value == "") {
            e.preventDefault();
            const errorBox = document.getElementById("ErrorBox");
            errorBox && errorBox.remove();
            const errorMsg = document.getElementsByClassName("errorMessage")[0];
            if (errorMsg) errorMsg.classList.remove("hide");
            codeInput.classList.add("input-validation-error");
            codeInput.setAttribute("aria-invalid", "true");
        }
    };

    const submitForm = (e) => {
        helpers.ClearStatus();
        const registerForm = document.getElementById("registerForm");

        if (registerForm) {
            forms.formValidation(
                registerForm,
                () => {
                    helpers.ShowBusyBtn(e.target); // only after validation succeeds
                    formSuccess();
                },
                e,
                () => {
                    if (helpers.HasBusyBtn?.()) {
                        helpers.RemoveBusyBtn();
                    }
                    resetSubmitButton();
                }
            );
        }
    };


    /*const removeLoading = () => {
        const form = document.getElementById("registerForm");
        const loading = form && form.querySelector(".spinner");
        if (loading) loading.remove();
    };*/

    const formSuccess = () => {
        const email = document.getElementById('Email');
        const registerForm = document.getElementsByClassName("RegistrationForm")[0];
        if (email && registerForm) saveEmailPreferences(email.value);
    };

    const getPrefs = (elements) => {
        if (!elements) return "";
        let emailPrefs = "";
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].value != '') {
                emailPrefs += elements[i].value + ":" + (elements[i].checked ? "true" : "false") + ",";
            }
        }
        return emailPrefs;
    };

    const saveEmailPreferences = async (emailAddress) => {
        const salePrefs = getPrefs(allSaleChecks);
        const productPrefs = getPrefs(allProductChecks);
        const newsPrefs = getPrefs(allNewsChecks);
        const emailPreferences = salePrefs + productPrefs + newsPrefs;
        const newUserData = { EmailPrefs: emailPreferences, EmailAddress: emailAddress };

        try {
            await fetch('/Esp/SaveNewUserSubscriptions', {
                method: 'POST',
                body: JSON.stringify(newUserData),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'fetch',
                    "__RequestVerificationToken": verificationToken,
                    "RequestVerificationToken": verificationToken
                }
            });
        } catch (error) {
            console.log(error);
        }
    };

    return { Init: init };
};

(async () => {
    const validateRegForms = new registerLogIn();
    validateRegForms.Init();
})();